import newFarm from './newFarm.svg'
import farmLengthLine from './farmLengthLine.svg'
import farmWidthLine from './farmWidthLine.svg';
import dropDownArrow from './dropDownArrow.svg'
export const newFarmIcon = newFarm;
export const farmLengthLIneIcon = farmLengthLine;
export const farmWidthLineIcon = farmWidthLine;
export const dropDownArrowIcon = dropDownArrow